export default {
  home: {
    buttonLabel: 'sample',
  },
};
